<template>
  <nav class="sidenav">
    <el-menu
      :default-active="active"
      :unique-opened="true"
      :default-openeds="opened"
      v-if="isReady"
      :collapse="bodyWidth < 1280"
    >
      <div
        v-for="menu in menus"
        v-if="permissionList === '' || checkMenuAuthority(menu)">
        <div v-if="menu.children">
          <el-submenu :index="`${menu.id}`">
            <template slot="title">
              <i :class="'iconfont '+menu.icon"></i>
              <span class="menu-name">{{menu.name}}</span>
            </template>
            <!--180开头为全渠道，在 crm2.0 及融合版中不控制二级菜单权限 -->
            <div v-for="child in menu.children"
                 v-if="permissionList === '' || checkMenuAuthority(child) || child.id === '600008'"
                 :class="child.className ? child.className : null">
              <el-menu-item :index="`${child.id}`" @click="jump(child.path)" v-lx="child.lx">{{child.name}}</el-menu-item>
            </div>
          </el-submenu>
        </div>
        <div v-else>
          <router-link :to="menu.path">
            <el-menu-item :index="`${menu.id}`">
              <i :class="'iconfont '+menu.icon"></i>
              <span slot="title" class="menu-name">{{menu.name}}</span>
            </el-menu-item>
          </router-link>
        </div>
      </div>
    </el-menu>
  </nav>
</template>

<script>
  import menu from '@constants/menu';
  import getRouterConf from '@util/getRouterConf';

  export default {
    props: ['menus'],
    data () {
      return {
        ctx: '/irs-web/index#',
        isReady: false,
        active: null,
        opened: [],
        permissionList: [],
        posVersionQualified: false,
        bodyWidth: document.body.clientWidth,
        dialogVisible:false
      };
    },
    created () {
      let _this = this;
      if (!localStorage.menuList) {
        _this.getPermissionList();
      } else {
        let menuList = JSON.parse(localStorage.menuList);
        _this.permissionList = menuList.crm || [];
        menuList.sys = menuList.sys || [];
        _this.permissionList = _this.permissionList.concat(menuList.sys);
        this.pushFirstPage();
        _this.isReady = true;
      }
      _this.checkBodyWidth();
      if (this.$route.path !== '/Midware' && this.$route.path !== '/MessageCenter' && this.$route.path !== '/') {
        // active 和 opened 的修改仅限于通过url跳页，鼠标点击菜单栏不需要此 watch
        const config = getRouterConf(this.$route.path);
        this.active = config[1].id.toString();
        this.opened = this.bodyWidth < 1280 ? [] : [config[0].id.toString()];
      }
    },
    watch: {
      '$route': function () {
        if (this.$route.path !== '/Midware' && this.$route.path !== '/MessageCenter' && this.$route.path !== '/') {
          // active 和 opened 的修改仅限于通过url跳页，鼠标点击菜单栏不需要此 watch
          const config = getRouterConf(this.$route.path);
          this.active = config[1].id.toString();
          this.opened = this.bodyWidth < 1280 ? [] : [config[0].id.toString()];
        }
      }
    },
    methods: {
      getPermissionList () {
        this.$axios.get('/hq-agency/user/menu').then((menu) => {
          if (menu.code === 200) {
            let menuList = {};
            menu.data.forEach(item => {
              menuList[item.systemCode] = item.menu.map((one) => {
                return one.id;
              });
            });
            localStorage.setItem('menuList', JSON.stringify(menuList));
            this.permissionList = menuList.crm || [];
            menuList.sys = menuList.sys || [];
            this.permissionList = this.permissionList.concat(menuList.sys);
            this.pushFirstPage();
            this.isReady = true;
          }
        });
      },
      pushFirstPage () {
        if (global.location.hash === '#/') {
          let authorityPath = '';
          for (let i = 0; i < menu.length; i ++) {
            for (let j = 0; j < menu[i].children.length; j ++) {
              if (this.checkMenuAuthority(menu[i].children[j])) {
                authorityPath = menu[i].children[j].path;
                break;
              }
            }
            if (authorityPath) {
              break;
            }
          }
          authorityPath && this.$router.push(authorityPath);    
        }
      },
      checkMenuAuthority (item) {
        let ids = [];
        if (item.children) {
          item.children.forEach(child => {
            if (child.children) {
              child.children.forEach(i => {
                ids.push(i.id);
              });
            } else {
              ids.push(child.id);
            }
          });
        } else {
          if (item.children) {
            item.children.forEach(i => {
              ids.push(i.id);
            });
          } else {
            ids.push(item.id);
          }
        }
        let flag = false;
        flag = ids.some(item => {
          // 180开头为全渠道，单店/门店在 crm2.0 及融合版中不控制二级菜单权限
          return this.permissionList.indexOf(+item) >= 0 || (item.startsWith('180') && (this.$agency.isHQHotel || this.$agency.isHotel));
        });
        return flag;
      },
      checkBodyWidth () {
        let _this = this;
        window.onresize = function () {
          _this.bodyWidth = document.body.clientWidth;
          _this.opened = _this.bodyWidth < 1280 ? [] : _this.opened;
        };
      },
      jump (path) {
        if (this.$route.path === path || this.$route.path === path + '/') {
          // 转到中间件来强制刷新当前 router-view
          this.$router.replace({
            path: '/Midware',
            query: {
              targetUrl: path
            }
          });
        } else {
          this.$router.push({
            path: path
          });
        }
      }
    },
  };
</script>

<style lang="less">
  nav {
    width: 200px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    .el-menu {
      border-right: 0 none;
    }
    .moreMessage {
      p {
        text-align: center;
      }
      
    }
  }
</style>



// WEBPACK FOOTER //
// SideNav.vue?1addedc9